class Std {
  static get String() {
    return StringExtended
  }

  static get Number() {
    return NumberExtended
  }

  static get Math() {
    return MathExtended
  }
}

class MathExtended {
  static get fromString() {
    return NumberExtended.fromString
  }

  static randomBetween(min = 1, max = 100) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  // Вычисляет среднее арифметическое массива
  static avg(arr) {
    return arr.reduce((sum, element) => sum += element, 0) / arr.length
  }

  // Вычисляет элемент геометрической прогрессии по указанному порядковому номеру
  static geom(firstElement, index, scaleFactor = 2) {
    return index > 0 ? firstElement * Math.pow(scaleFactor, index - 1) : firstElement
  }
}

class StringExtended extends String {
  static trimOrEmpty(string) {
    if (typeof string !== 'string') {
      return ''
    }

    return string.trim()
  }

  static toBase64(string) {
    return Buffer.from(string, 'utf8').toString('base64')
  }

  static toString(input) {
    return '' + (input || '')
  }

  /**
   * @param {string} string
   * @param {number} length
   * @returns {string[]}
   */
  static splitString(string, length = string.length) {
    const chunks = []
    const stringLength = string.length

    for (let offset = 0; offset < stringLength; offset += length) {
      chunks.push(string.substring(offset, offset + length))
    }

    return chunks
  }

  /**
   * Удаляет двойные слэши
   *
   * @param {string} [string='']
   * @returns {string}
   */
  static removeDoubleSlashes(string = '') {
    return string.replace(/\/{2,}/g, '/')
  }

  static removeNullBytes(string) {
    return string.replace(/\\u0000/g, '').replace(/\u0000/g, '')
  }
}

class NumberExtended extends Number {
  /**
   * @param {any} stringNumber
   * @returns {number|void}
   */
  static fromString(stringNumber) {
    if (typeof stringNumber === 'string' && stringNumber) {
      stringNumber = parseInt(stringNumber.trim())
    }

    if (typeof stringNumber !== 'number' || isNaN(stringNumber)) {
      return
    }

    return stringNumber
  }
}

module.exports = Std